export const environment = {
  production: true,
  isCozentusEnvironment : true,
  baseApiUrl:'https://governancedev.cozentus.com:8125/api/',
  redirectUriBasePath :'',
  sso:{
    adClientId:'1b087f04-bed5-42f7-98c4-9ac608f9bb25',
    adTenantId : 'cd3779f6-2af9-4aee-be9a-45e131119f0b'
  },
  msalLogInRequest : ['api://1b087f04-bed5-42f7-98c4-9ac608f9bb25/access-user']
};
